import * as Yup from 'yup';
import { emailRequired, stringOptional, stringRequired } from '.';

export const UpdateProfileSchema = Yup.object({
    first_name: stringOptional,
    middle_name: stringOptional,
    last_name: stringOptional,
    email: emailRequired,
    phone_number: stringRequired,
    state: stringOptional,
    city: stringOptional,
    country: stringOptional,
    zip_code: stringOptional,
    profile_picture: stringOptional
});